import {
  AppKeys,
  newMsg,
  MessageType,
  newTag,
} from '../../../core/localization';
import { Groups } from '../../../models';

export const msgHeader = newMsg(AppKeys.Download_Header);
export const msgHistoryBtn = newMsg(AppKeys.Btn_History);
export const msgDownloadBtn = newMsg(AppKeys.Btn_Download);

export const msgDownloading = newMsg(AppKeys.Download_Updating);

export const msgSplitFileWarn = (fileType: string) =>
  newMsg(AppKeys.Download_SplitFile_Warn, [
    { tag: 'fileType', value: fileType },
  ]);

export const msgFileFormatLabel = newMsg(AppKeys.Download_FileType_Label);
export const msgKEMPwdLabel = newMsg(AppKeys.Download_PwdKem_Label);
export const msgKEMPwdInfo = newMsg(AppKeys.Download_PwdKem_Info);
export const msgKEMPwdWarn = newMsg(AppKeys.Download_PwdKem_Warn);
export const msgKEMPwdError = newMsg(AppKeys.Download_PwdKem_Error);

export const msgDevicesAll = newMsg(AppKeys.Devices_Mode_All);
export const msgDevicesSelected = newMsg(AppKeys.Devices_Mode_Selected);

export const msgSubtextOrders = (total: number) =>
  newMsg(AppKeys.Download_Subtext_Orders, [{ tag: 'total', value: total }]);

export const msgSubtextDTypes = (total: number) =>
  newMsg(AppKeys.Download_Subtext_DTypes, [{ tag: 'total', value: total }]);

export const msgSubtextCustomers = (total: number) =>
  newMsg(AppKeys.Download_Subtext_Customers, [{ tag: 'total', value: total }]);

export const getViewMsg = (groupedBy: Groups, numKeys: number) => {
  switch (groupedBy) {
    case Groups.ORDERS:
      return msgSubtextOrders(numKeys);
    case Groups.DEVICETYPES:
      return msgSubtextDTypes(numKeys);
    case Groups.CUSTOMERS:
      return msgSubtextCustomers(numKeys);
    default:
      return '' as MessageType;
  }
};

export const msgNotImplemented = (downloadType: string) =>
  newMsg(AppKeys.ApiMykeys_Download_NotImpl, [
    { tag: 'downloadType', value: downloadType },
  ]);

export const msgDownloadSuccess = (total: number) =>
  newMsg(AppKeys.ApiMykeys_Download_Success, [{ tag: 'count', value: total }]);

export const msgSigFoxWarn = newMsg(AppKeys.Download_Sigfox_Warn);
export const msgSigFoxError = newMsg(AppKeys.ApiMykeys_Download_Error_SigFox);
export const msgUnsecureHeader = newMsg(AppKeys.Download_Unsecure_Header);
export const msgUnsecureDesc = newMsg(AppKeys.Download_Unsecure_Desc);

export const msgUnsecureDeadline = (date: string) =>
  newMsg(AppKeys.Download_Unsecure_Deadline, [newTag('date', date)]);
export const msgUnsecureExtra = newMsg(AppKeys.Download_Unsecure_Extra);

export const msgOnlyDevicesOneCustomerError = newMsg(
  AppKeys.ApiMykeys_Download_Error_OneCustomer
);

export const msgDownloadError = (downloadType: string) =>
  newMsg(AppKeys.ApiMykeys_Download_Error, [newTag('filetype', downloadType)]);

export const msgDownloadPartialWarning = newMsg(AppKeys.ApiMykeys_Download_Partial_Warning);

export const msgDownloadNoneWarning = newMsg(AppKeys.ApiMykeys_Download_None_Warning);
